<p-card>
    <p-table
        #dt
        [value]="products"
        dataKey="id"
        [lazy]="true"
        [paginator]="true"
        [totalRecords]="resultsLength"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="{first} - {last} sur {totalRecords}"
        [rows]="pageSize"
        [rowsPerPageOptions]="[10, 20, 50]"
        [columns]="selectedColumns"
        [loading]="isLoadingResults"
        [scrollable]="true"
        scrollHeight="634px"
        (onLazyLoad)="onLazyLoad($event)"
        (onStateRestore)="onStateRestore($event)"
        stateKey="_pmpe"
        stateStorage="local"
    >
        <ng-template #header let-columns>
            <tr>
                @for (col of columns; track $index) {
                    <th>{{ col.header }}</th>
                }
                <th class="w-12"></th>
            </tr>
        </ng-template>

        <ng-template #body let-product let-columns="columns">
            <tr>
                @for (col of columns; track $index) {
                    @switch (col.field) {
                        @case ('produit_id') {
                            <td class="w-32">
                                <a [routerLink]="['/products', product.id]" class="flex flex-col justify-center items-center">
                                    <img [src]="apiUrl + product.photo_couverture" alt="{{product.reference}}" width="80" height="80" class="h-20 w-20 shadow-lg object-cover rounded-md" />
                                    <p-tag severity="contrast" [value]="'#' + product.id" class="-mt-3 relative z-0 !text-base" />
                                </a>
                            </td>
                        }
                        @case ('marque') {
                            <td>{{ product[col.field]?.nom }}</td>
                        }
                        @case ('modification_ebay_le') {
                            <td>{{ product[col.field] | date:'shortDate' }}</td>
                        }
                        @case ('colonnes_modifies') {
                            <td>
                                <div class="flex flex-row gap-2">
                                    @for (modif of product[col.field]; track modif) {
                                        <p-tag [value]="modif" [rounded]="true" severity="contrast"></p-tag>
                                    }
                                </div>
                            </td>
                        }
                        @default {
                            <td>{{ product[col.field] }}</td>
                        }
                    }
                }
                <td class="w-12">
                    <p-button (click)="onValidatingModification(product)" [loading]="isSending(product)" icon="pi pi-check" [rounded]="true" text pTooltip="J'accuse lecture des modifications" tooltipPosition="left"/>
                </td>
            </tr>
        </ng-template>
    </p-table>
</p-card>
